import { UserComponent } from '@craftjs/core';
import { FormFieldProps, FormFieldWithScoreProps } from './BaseControlTypes';
import { createId } from 'src/helpers/typeUtils';

export type FormDateInputProps = FormFieldProps;

export const formDateInputDefaultProps: FormDateInputProps = {
  title: 'Form date input',
  dataKey: createId(),
};

export type FormDateInputComponent = UserComponent<FormDateInputProps>;

export const formDateRangeInputDefaultProps: FormDateInputProps = {
  title: 'Form date range input',
  dataKey: createId(),
};

export type FormDateRangeInputComponent = UserComponent<FormDateInputProps>;

export type FormTimeInputProps = FormFieldProps &
  FormFieldWithScoreProps & {
    placeholder?: string;
    timeIntervalInMinutes?: number;
  };

export const formTimeInputDefaultProps: FormTimeInputProps = {
  title: 'Form time input',
  dataKey: createId(),
  timeIntervalInMinutes: 30,
};

export type FormTimeInputComponent = UserComponent<FormTimeInputProps>;
